import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    label: {
        '&[data-error="true"]': {
            color: theme.palette.error.main,
        },
        '& p': {
            margin: 0,
        },
        fontWeight: 500,
        fontSize: '0.875rem',
        width: 'fit-content',
    },
    select: {
        width: 425,
        height: 32,
        '&.MuiOutlinedInput-root': {
            '& > .MuiSelect-select': {
                resize: 'none',
                fontFamily: 'Arial',
                fontSize: '13.333px',
            },
            border: `1px solid ${theme.palette.grey.border}`,
            borderRadius: '0.25em',
        },
    },
    option: {
        '&.MuiMenuItem-root': {
            fontFamily: 'Arial',
            fontSize: '13.333px',
        },
    },
    spinner: {
        animation: 'spin 2s linear infinite',
        marginLeft: '1rem',
    },
    invalidReason: {
        display: 'block',
        color: theme.palette.error.main,
    },
    required: {
        '& > p::before': {
            content: '"*"',
            color: '#D24444',
            marginRight: '0.25rem',
        },
    },
}));

export default useStyles;
